import { render } from "./Screen.vue?vue&type=template&id=41307e84&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"

import "./Screen.vue?vue&type=style&index=0&id=41307e84&lang=scss&scoped=true"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41307e84"]])

export default __exports__